import { useTranslation } from 'react-i18next'

import Button from '../../Button'

function TableModalButtonConfirm({
  Component = Button.Contained,
  text = 'Modal.ConfirmActionKey',
  ...restProps
}) {
  const { t } = useTranslation()

  return <Component {...restProps} text={t(text)} />
}

export default TableModalButtonConfirm
